import { LOCALE } from '../config'

export default {
  name: LOCALE['zh-cn'],
  plus: {
    table: {
      operate: '操作',
    },
  },
}
